<template>
  <div class="section-image" :class="{ '-reverse': reverse }">
    <div
      class="section-image__image"
      :class="{ '-nohover': !gallery }"
      v-if="images[0]"
      @click="$emit('caroussel')"
    >
      <img :src="images[0].sm || images[0].md || images[0].original" alt="img" />
      <svg
        v-if="gallery"
        id="uuid-b58c288a-d4e5-46ed-ac47-d36cf98090fa"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24.92999 18.52997"
      >
        <path
          d="m0,0v18.52997h24.92999V0H0Zm5.45996,17.52997l3.97003-5.81,3.96997,5.81h-7.94Zm9.15002,0l-2.46002-3.60999,3.31-4.85004,5.78003,8.46002h-6.63Zm9.32001,0h-1.48999l-6.98004-10.23999-3.91998,5.75-2.10999-3.09998-5.17004,7.58997H1V1h22.92999v16.52997Z"
        ></path>
        <path
          d="m6.62885,9.04956h-.00098c-1.3833,0-2.50879-1.12549-2.50879-2.50879s1.12549-2.50879,2.50879-2.50879c1.38379,0,2.50928,1.12549,2.50928,2.50879,0,.67041-.26123,1.30029-.73486,1.77393-.47363.47412-1.10352.73486-1.77344.73486Zm-.00098-4.01758c-.83203,0-1.50879.67676-1.50879,1.50879s.67676,1.50879,1.50879,1.50879h.00049c.40332,0,.78174-.15674,1.06689-.44189.28516-.28467.44189-.66406.44189-1.06689,0-.83203-.67725-1.50879-1.50928-1.50879Z"
        ></path>
      </svg>
    </div>
    <div class="section-image__content">
      <div class="section-image__title">{{ title }}</div>
      <div class="section-image__text" v-html="text" />
      <button :class="white ? 'button-white' : 'button'" @click="openLink">
        {{ button.label }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionImage',
  props: {
    gallery: {
      type: Boolean,
      default: true,
    },
    images: {
      type: Array,
      default: () => [],
    },
    white: {
      type: Boolean,
      default: false,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    button: {
      label: '',
      link: '',
    },
    title: {
      type: String,
      default: 'title',
    },
    text: {
      type: String,
      default: `Découvrez une expérience intime dans nos salons privés. Ces espaces élégants et raffinés sont le cadre parfait pour les groupes qui cherchent à savourer une expérience gastronomique inoubliable. Nos 2 salons privés peuvent accueillir des groupes de 10 ou 26 personnes. Connectés par des portes normalement fermées, ils peuvent être transformés en un grand salon pour 40 personnes.

Que ce soit pour des événements professionnels, des célébrations personnelles ou simplement pour une soirée entre amis; peu importe l’occasion qui vous réunit, notre équipe vous réserve un accueil chaleureux et un moment inoubliable.

Contactez-nous par téléphone au 418-524-8228 ou par courriel au info@restaurantophelia.com pour réserver!`,
    },
    image: {
      type: String,
      default: 'https://placehold.co/600x400',
    },
  },
  methods: {
    openLink() {
      window.open(this.button.link, '_blank')
    },
  },
}
</script>
